export default __webpack_public_path__ + "static/media/DAIF_UseCase_Screen4_in.dde08177.mp4";